export const InitialValuesAddDpgf = {
	unit: "",
	content: "",
	total: "",
	vta: "",
	cctpIri: ""
}